import { api } from './api';
import type { AcousticCalibrationStore } from './acoustic/calibrationTypes';
import type { AcousticCalibrationSnapshot } from './acoustic/calibrationTypes';
import type { AcousticThresholdOverrideStore } from './acoustic/acousticThresholdOverrides';

type ApiEnvelope<T> = { success: boolean; data?: T; error?: string };

export async function fetchAcousticThresholdsFromServer(): Promise<AcousticThresholdOverrideStore | null> {
  try {
    const res = await api.get<ApiEnvelope<AcousticThresholdOverrideStore>>('/acoustic-calibration/thresholds');
    if (!res.data?.success || !res.data.data) return null;
    return res.data.data;
  } catch {
    return null;
  }
}

export async function saveAcousticThresholdsToServer(
  store: AcousticThresholdOverrideStore
): Promise<AcousticThresholdOverrideStore | null> {
  try {
    const res = await api.put<ApiEnvelope<AcousticThresholdOverrideStore>>('/acoustic-calibration/thresholds', {
      empiricalGlobalActive: store.empiricalGlobalActive,
      byTag: store.byTag,
      merged: store.merged,
      version: store.version
    });
    if (!res.data?.success || !res.data.data) return null;
    return res.data.data;
  } catch {
    return null;
  }
}

export async function fetchAcousticSnapshotsFromServer(): Promise<AcousticCalibrationStore | null> {
  try {
    const res = await api.get<ApiEnvelope<AcousticCalibrationStore>>('/acoustic-calibration/snapshots');
    if (!res.data?.success || !res.data.data) return null;
    return res.data.data;
  } catch {
    return null;
  }
}

export async function saveAcousticSnapshotToServer(snapshot: AcousticCalibrationSnapshot): Promise<boolean> {
  try {
    const res = await api.post<ApiEnvelope<unknown>>('/acoustic-calibration/snapshots', { snapshot });
    return Boolean(res.data?.success);
  } catch {
    return false;
  }
}

export async function replaceAcousticSnapshotsOnServer(
  snapshots: AcousticCalibrationSnapshot[]
): Promise<boolean> {
  try {
    const res = await api.put<ApiEnvelope<{ count: number }>>('/acoustic-calibration/snapshots', { snapshots });
    return Boolean(res.data?.success);
  } catch {
    return false;
  }
}

export async function deleteAcousticSnapshotOnServer(id: string): Promise<boolean> {
  try {
    const res = await api.delete<ApiEnvelope<unknown>>(`/acoustic-calibration/snapshots/${id}`);
    return Boolean(res.data?.success);
  } catch {
    return false;
  }
}

export async function clearAcousticSnapshotsOnServer(): Promise<boolean> {
  try {
    const res = await api.delete<ApiEnvelope<unknown>>('/acoustic-calibration/snapshots');
    return Boolean(res.data?.success);
  } catch {
    return false;
  }
}
